import { BlokProps, withStoryblokEditable } from "@helpers/StoryblokHelpers"
import { ServiceTypeStoryblok, VaccineTypePageStoryblok } from "@storyblok-types"
import { StoryblokServerComponent } from "@storyblok/react/rsc"
import PageContainer from "@ui-library/layout/PageContainer"

interface ServiceTypePageProps {
  blok: BlokProps<VaccineTypePageStoryblok>["blok"]
  service: ServiceTypeStoryblok | undefined
  /** Resolved from `relation_id` by the page — see getRelatedVaccines. */
  relatedServices?: ServiceTypeStoryblok[]
}

export const ServiceTypePage = ({ blok, service, relatedServices }: ServiceTypePageProps) => {
  return (
    <PageContainer background={blok.background} extraHeight={false} {...withStoryblokEditable(blok)}>
      {blok.body.map(nestedBlok => (
        <StoryblokServerComponent
          blok={nestedBlok}
          key={nestedBlok._uid}
          service={service}
          relatedServices={relatedServices}
        />
      ))}
    </PageContainer>
  )
}

export default ServiceTypePage
